import React from 'react'

export const Dot = () => <span>&nbsp; &#183; &nbsp;</span>
